import React, { FC } from 'react';

import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import { ScrollbarTheme } from 'components/horizontal-scroller/horizontal-scroller';
import { ModalSize } from 'components/modal';
import { ResponsiveCarousel } from 'components/responsive-carousel';

import ModalSurpriseCard from './modal-surprise-card';
import {
  Container,
  Description,
  Prompt,
  RejectSurprise,
  StyledCloseButton,
  StyledModal,
  SurpriseButtons,
  SurpriseInfo,
  SurpriseOptions,
  Terms,
  TitleContainer,
} from './modal-surprise.styled';
import { ILoyaltySurpriseViewProps } from './types';

const ModalSurpriseView: FC<ILoyaltySurpriseViewProps> = ({
  offers,
  selectedOffer,
  modalContent,
  handleAddSurprise,
  handleDismiss,
  handleSelectOffer,
}) => {
  return (
    <StyledModal
      mParticleEventData={{
        modalAppearanceEventMessage: 'Loyalty Surprise & Delight',
      }}
      data-testid="surprise-modal"
      size={ModalSize.FULLSCREEN}
      backgroundColor={Styles.color.teal}
      onDismiss={handleDismiss}
      closeButton={props => <StyledCloseButton {...props} inverted />}
    >
      <Container>
        <SurpriseInfo>
          <TitleContainer backgroundImage={modalContent.bgImage ?? ''}>
            <h2>{modalContent.title}</h2>
          </TitleContainer>
          <Description>{modalContent.description}</Description>
          <SurpriseOptions>
            <Prompt>{modalContent.prompt}</Prompt>
            {Boolean(offers?.length) && (
              <ResponsiveCarousel scrollbarTheme={ScrollbarTheme.LIGHT} centerCards>
                {offers.map(offer => (
                  <ModalSurpriseCard
                    key={offer._id}
                    offer={offer}
                    checked={Boolean(selectedOffer) && offer._id === selectedOffer?._id}
                    handleSelectOffer={handleSelectOffer}
                  />
                ))}
              </ResponsiveCarousel>
            )}
          </SurpriseOptions>
        </SurpriseInfo>
        <SurpriseButtons>
          <ActionButton
            size={ActionButtonSizes.LARGE}
            variant={ActionButtonVariants.INVERSE}
            onClick={() => handleAddSurprise(selectedOffer)}
            disabled={!selectedOffer}
            data-testid="add-free-surprise"
          >
            {modalContent.buttonText}
          </ActionButton>
          <RejectSurprise onClick={handleDismiss} data-testid="reject-surprise">
            {modalContent.noThanksText}
          </RejectSurprise>
          <Terms content={modalContent.termsText} />
        </SurpriseButtons>
      </Container>
    </StyledModal>
  );
};
export default ModalSurpriseView;
